webpackJsonp([52267211011875],{

/***/ 1395:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"div","properties":{},"children":[{"type":"text","value":"\n"},{"type":"element","tagName":"vocabularium","properties":{},"children":[]},{"type":"text","value":"\n"}]}],"data":{"quirksMode":false}},"frontmatter":{"title":"Vocabularium"}}},"pathContext":{"slug":"/vocabularium/","title":"Vocabularium"}}

/***/ })

});


// WEBPACK FOOTER //
// path---vocabularium-48a3e5acea22f3e96f71.js